import { Controller } from "@hotwired/stimulus"

const LITERS_PER_GALLON = 3.78541

export default class extends Controller {
  static targets = ["input", "gallonsField", "hint", "galBtn", "lBtn", "savedIndicator"]
  static values = { unit: { type: String, default: "gal" } }

  connect() {
    this.updateHint()
    this._onSubmitEnd = ({ detail: { success } }) => { if (success) this._flashSaved() }
    this.inputTarget.closest("form")?.addEventListener("turbo:submit-end", this._onSubmitEnd)
  }

  disconnect() {
    this.inputTarget.closest("form")?.removeEventListener("turbo:submit-end", this._onSubmitEnd)
  }

  setGal() {
    if (this.unitValue === "gal") return
    const liters = parseFloat(this.inputTarget.value)
    if (!isNaN(liters)) {
      this.inputTarget.value = (liters / LITERS_PER_GALLON).toFixed(1)
    }
    this.unitValue = "gal"
    this.syncGallonsField()
    this.updateHint()
    this.updateToggle()
  }

  setL() {
    if (this.unitValue === "L") return
    const gallons = parseFloat(this.inputTarget.value)
    if (!isNaN(gallons)) {
      this.inputTarget.value = (gallons * LITERS_PER_GALLON).toFixed(1)
    }
    this.unitValue = "L"
    this.syncGallonsField()
    this.updateHint()
    this.updateToggle()
  }

  update() {
    this.syncGallonsField()
    this.updateHint()
    this.autoSave()
  }

  autoSave() {
    clearTimeout(this._saveTimer)
    if (!this.gallonsFieldTarget.value) return
    this._saveTimer = setTimeout(() => {
      this.inputTarget.closest("form")?.requestSubmit()
    }, 750)
  }

  _flashSaved() {
    // Mark the diluent section as no longer missing so the wizard treats it as saved
    this.element.closest("[data-diluent-missing]")?.removeAttribute("data-diluent-missing")

    const el = this.savedIndicatorTarget
    el.classList.remove("opacity-0")
    el.classList.add("opacity-100")
    clearTimeout(this._fadeTimer)
    this._fadeTimer = setTimeout(() => {
      el.classList.remove("opacity-100")
      el.classList.add("opacity-0")
    }, 1500)
  }

  syncGallonsField() {
    const val = parseFloat(this.inputTarget.value)
    if (isNaN(val)) {
      this.gallonsFieldTarget.value = ""
      return
    }
    if (this.unitValue === "gal") {
      this.gallonsFieldTarget.value = val
    } else {
      this.gallonsFieldTarget.value = (val / LITERS_PER_GALLON).toFixed(2)
    }
  }

  updateHint() {
    const val = parseFloat(this.inputTarget.value)
    if (isNaN(val) || val === 0) {
      this.hintTarget.textContent = ""
      return
    }
    if (this.unitValue === "gal") {
      this.hintTarget.textContent = `${Math.round(val * LITERS_PER_GALLON)} L`
    } else {
      this.hintTarget.textContent = `${(val / LITERS_PER_GALLON).toFixed(1)} gal`
    }
  }

  updateToggle() {
    if (this.unitValue === "gal") {
      this.galBtnTarget.classList.add("btn-active")
      this.lBtnTarget.classList.remove("btn-active")
    } else {
      this.galBtnTarget.classList.remove("btn-active")
      this.lBtnTarget.classList.add("btn-active")
    }
  }
}
